export default "__VITE_ASSET__Bu08A41J__"